import React from 'react';
import { MainLoading } from './style';
import Logo from '../../../assets/images/01.png'

function index() {
    return (
        <MainLoading>
            <img src={Logo} alt='Logo' />
        </MainLoading>
    )
}

export default index;
